// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../rescript/lib/es6/curry.js";
import * as React from "react";
import * as ErrorUtils$Catalyst from "../../utils/ErrorUtils.bs.js";
import ReactDependentScript from "react-dependent-script";
import * as CircularLoader$Catalyst from "../../components/generic/loaders/CircularLoader.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../components/custom/error/ErrorDisplayComponent.bs.js";

var ReactDependentScript$1 = {};

function ScriptFetcher(Props) {
  var scripts = Props.scripts;
  var children = Props.children;
  var loaderclassNameOpt = Props.loaderclassName;
  var errorclassNameOpt = Props.errorclassName;
  var timeoutOpt = Props.timeout;
  var loaderclassName = loaderclassNameOpt !== undefined ? loaderclassNameOpt : "";
  var errorclassName = errorclassNameOpt !== undefined ? errorclassNameOpt : "";
  var timeout = timeoutOpt !== undefined ? timeoutOpt : 5000;
  var match = React.useState(function () {
        return false;
      });
  var setIsError = match[1];
  return React.createElement(ReactDependentScript, {
              loadingComponent: match[0] ? (console.log("Map load fail"), React.createElement(ErrorDisplayComponent$Catalyst.make, {
                        error: ErrorUtils$Catalyst.getDefaultErrorEntity("The component failed to load", undefined, undefined),
                        className: errorclassName
                      })) : (setTimeout((function (param) {
                          return Curry._1(setIsError, (function (param) {
                                        return true;
                                      }));
                        }), timeout), React.createElement(CircularLoader$Catalyst.make, {
                        className: loaderclassName
                      })),
              scripts: scripts,
              renderChildren: (function (param) {
                  return children;
                })
            });
}

var make = ScriptFetcher;

export {
  ReactDependentScript$1 as ReactDependentScript,
  make ,
  
}
/* react Not a pure module */
